import { Values } from 'components/desktop/_general/NutritionFactsLabel/NutritionFactsLabel';
import { Value } from 'components/desktop/_general/NutritionFactsLabel/NutritionFactsLabel';
import NutritionFactsLabel from 'components/desktop/_general/NutritionFactsLabel/NutritionFactsLabel';
import { nutritionFactsLabelInformations } from 'constants/nutritionFactsLabelInformations';
import * as Calculation from 'types/Recipe/Calculation';
import { Recipe } from 'types/Recipe/Recipe';
import { SimpleNumber } from 'types/_general/SimpleNumber';

interface Props {
	calculation: Calculation.Type;
	recipe: Recipe;
}

const NutritionFactsLabelWrapper = ({ calculation, recipe }: Props) => {
	if (!calculation) return <></>;

	const values: Values = {} as Values;

	for (const i of nutritionFactsLabelInformations) {
		const value: number = Calculation.calculateTotalById(calculation, i.id, recipe.parts ?? 1);
		const unit: string = Calculation.getUnitById(calculation, i.id);
		const percent: number = Calculation.calculateDailyValueById(
			calculation,
			i.id,
			recipe.parts ?? 1,
			i.dailyValue
		);
		values[i.name] = {} as Value;
		values[i.name].value = value;
		values[i.name].unit = unit;
		if (!i.dailyValue) continue;
		values[i.name].percent = percent;
	}
	if (!values.calories.value)
		values.calories.value =
			(calculation.calories ?? 1) / SimpleNumber.ifNullOrZeroMakeOne(recipe.parts);

	const calculateServingSize = {
		value:
			(calculation.weight ?? recipe.ingredientWeight ?? recipe.weight ?? 1) /
			(recipe.parts ?? 1),
		unit: 'g',
	};

	return <NutritionFactsLabel values={values} servingSize={calculateServingSize} />;
};

export default NutritionFactsLabelWrapper;
